import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-invoice-status-graph',
    templateUrl: './invoice-status-graph.component.html',
    styleUrls: ['./invoice-status-graph.component.scss'],
    standalone: false
})
export class InvoiceStatusGraphComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
